import { useEffect, useState } from "react";
import DoneModal from "../dashboard/doneModal";
import clockIcon from "../../images/clockIcon.svg";
import trashIcon from "../../images/trashIcon.svg";
import checkCircleIcon from "../../images/checkCircleIcon.svg";
import editIcon from "../../images/editIcon.svg";
import ReminderPopup from "../reminderPopup/reminderPopup";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { resources_EN } from "../componentUtils";
import { PostService } from "../../services/genericPostService";
import { Path } from "../../RoutesUtils";
import calendarIcon from "../../images/calendarIcon.svg";
const TaskCard = ({
  task_image,
  task_title,
  isPage = false,
  task_start_time,
  task_end_time,
  task_id,
  getTasks,
  task_date,
  task_desc,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReminderOpen, setIsReminderOpen] = useState(false);

  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  /* Delete Task */
  const deleteTask = () => {
    const data = {
      user_id: userId,
      task_id: task_id,
    };
    const url = "/fmeApi/delete_task.php";
    PostService(url, data, modal);
  };

  /* Generic Modal */
  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        getTasks();
      }
    });
  };

  /* Confirmation Modal */
  const confirmationModal = () => {
    Swal.fire({
      title: "Er du sikker?",
      text: "Du vil ikke kunne fortryde dette!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ja, slet det!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteTask();
      }
    });
  };

  /* Redirect to Edit */
  const redirectEdit = () => {
    navigate(Path.editTask, {
      state: {
        task_id: task_id,
        task_title: task_title,
        task_start_time: task_start_time,
        task_end_time: task_end_time,
        task_date: task_date,
        task_image: task_image,
        task_desc: task_desc,
      },
    });
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="bg-theme rounded-xl p-4 overflow-hidden shadow">
        <div className="bg-white w-full h-32 p-5 rounded-lg">
          <img
            src={"../../fmeApi/" + task_image || "/placeholder.svg"}
            alt={task_title}
            className="w-full h-full object-contain"
          />
        </div>
        {/* <img
          src={"../../fmeApi/" + task_image || "/placeholder.svg"}
          alt={task_title}
          className="w-full h-32 object-cover rounded-lg"
        /> */}
        <div className="pt-4 pb-1">
          <p className="text-sm text-white mb-3">{task_title}</p>
          <div className="flex flex-col text-md font-semibold">
            <div className="flex items-center mb-2 text-white">
              <img
                src={clockIcon}
                className="mr-1 brightness-[999] h-6 w-6"
                alt=""
              />
              {task_start_time}-{task_end_time}
            </div>
            <div className="flex items-center mb-4 text-white text-sm">
              <img
                src={calendarIcon}
                className="mr-1 brightness-[999]"
                alt=""
              />
              {task_date}
            </div>
            <div className="flex justify-between gap-2 text-sm">
              {isPage ? (
                <a
                  className="flex text-green items-center cursor-pointer"
                  onClick={redirectEdit}
                >
                  <img src={editIcon} className="mr-1" alt="" />
                  Redigere
                </a>
              ) : (
                <button
                  onClick={() => { }}
                  className="flex text-green items-center text-[12px]"
                >
                  <img src={checkCircleIcon} className="mr-1" alt="" />
                  Marker det som udført
                </button>
              )}
              <button
                onClick={confirmationModal}
                className="flex items-center text-[#F02B2B]"
              >
                <img src={trashIcon} className="mr-1" alt="" />
                Slet
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Component */}
      <DoneModal isOpen={isModalOpen} onClose={closeModal} />
      {/* Reminder Modal Component */}
      <ReminderPopup
        isOpen={isReminderOpen}
        onClose={() => setIsReminderOpen(false)}
        data={[]}
      />
    </>
  );
};

export default TaskCard;
